import React from "react";
import { connect } from "react-redux";
import { redirectToAirline } from "../shared/utils";
import PubSub from "pubsub-js";
import "../shared/pubsub-triggers";

export const RedirectAirlineModal = props => {
	const outputFlight = stretch => {
		if (props.selectedFlights[stretch].length > 0) return props.selectedFlights[stretch][0];

		return null;
	};

	const filterOnlySelectedFlight = (direction, props) => {
		return {
			outbound: direction === "outbound" ? [props.selectedFlights.outbound[0]] : null,
			inbound: direction === "inbound" ? [props.selectedFlights.inbound[0]] : null
		};
	};

	const close = event => {
		event.preventDefault();
		props.closeModal();
	};

	
	if (props.open) {
		let flights =
		props.searchParams.tripType === "RT"
		? props.selectedFlights
		: filterOnlySelectedFlight(props.flightDirection, props);
		
		let direction = props.flightDirection === "inbound" ? "inbound" : "outbound";
		
		let redirectToCompany = props.searchParams.tripType === "RT" ? true : false;
		
		return (
			<div className="tingle-modal-box">
				<div className="modal-header-wrapper modal-header-wrapper--centered">
					<a className="close-modal" onClick={event => close(event)}>
						<i className="icon-close" />
					</a>
					<h3 className="lead">
						Você está saindo do site da MaxMilhas e será direcionado para o site da companhia aérea.
					</h3>
					<p>
						A partir de agora, sua compra será feita diretamente com a companhia aérea. Por isso,
						pode ser que as <strong>regras de bagagem</strong> e os{" "}
						<strong>valores das passagens</strong> sofram <strong>alterações.</strong> Combinado?
					</p>
				</div>
				<div className="tingle-modal-box__content">
					<button
                        className="btn btn-success"
                        data-action="buy-on-airline-website"
						onClick={() => {
							PubSub.publish("dataLayer", {
								event: "ditoTrack",
								ditoTrack: {
									action: "comprar-cia"
								}
							});

							PubSub.publish("dataLayer", {
								event: "gaEvent",
								gaEventCategory: "Processo de compra",
								gaEventAction: "Comprar na CIA",
								gaEventLabel: "",
								gaEventValue: ""
							});

							redirectToAirline(
								outputFlight(direction),
								flights,
								props.createCheckoutData.searchId,
								props.searchParams,
								window,
								direction,
								redirectToCompany
							);
						}}
					>
						Pesquisar no site da companhia aérea
					</button>
				</div>
			</div>
		);
	}

	return null;
};

const mapStateToProps = state => {
	return {
		selectedFlights: state.selectedFlights,
		createCheckoutData: {
			selectedFlights: state.selectedFlights,
			searchId: state.searchStatus.searchId,
			legacyId: state.searchStatus.legacyId,
			outboundId:
				state.selectedFlights.outbound.length > 0 ? state.selectedFlights.outbound[0].id : null,
			inboundId:
				state.selectedFlights.inbound.length > 0 ? state.selectedFlights.inbound[0].id : null
		},
		searchParams: state.searchParams.params,
		flightDirection: state.modal.flightDirection
	};
};

export default connect(mapStateToProps)(RedirectAirlineModal);
